<template>
	<app>
		<crumb-bar></crumb-bar>
		<module>
			<c-title>申请项目人员变更</c-title>
			<c-form ref="form" unit-width="970">
				<c-form-item type="hidden" name="ry_id"></c-form-item>
				<c-form-item v-model="currentProjectId" type="select" label="项目名称" name="project_id" :options="projectList" required :disabled="!!id"></c-form-item>
				<c-form-item type="input" label="业主单位" name="yzdw_name" required disabled></c-form-item>
				<c-form-item type="input" label="监理单位" name="jldw_name" required disabled></c-form-item>
				<c-form-item type="input" label="企业名称" name="zbqy_name" required disabled></c-form-item>
				<c-form-item type="input" label="项目经理" name="xmjl_xm" required width="50%" unit-width="440"></c-form-item>
				<c-form-item type="input" label="项目经理电话" name="xmjl_lxdh" required width="50%" unit-width="370"></c-form-item>
				<c-form-item type="input" label="技术总工" name="jszg_xm" required width="50%" unit-width="440"></c-form-item>
				<c-form-item type="input" label="技术总工电话" name="jszg_lxdh" required width="50%" unit-width="370"></c-form-item>
				<c-form-item type="input" label="安全员" name="aqy_xm" required width="50%" unit-width="440"></c-form-item>
				<c-form-item type="input" label="安全员电话" name="aqy_lxdh" width="50%" unit-width="370"></c-form-item>
				<c-form-item type="input" label="施工员" name="sgy_xm" required width="50%" unit-width="440"></c-form-item>
				<c-form-item type="input" label="施工员电话" name="sgy_lxdh" width="50%" unit-width="370"></c-form-item>
				<c-form-item type="input" label="质检员" name="zjy_xm" required width="50%" unit-width="440"></c-form-item>
				<c-form-item type="input" label="质检员电话" name="zjy_lxdh" width="50%" unit-width="370"></c-form-item>
				<c-form-item type="textarea" label="变更说明" name="remark"></c-form-item>
				<c-form-item type="file" label="其它材料" name="file_path" file-type="word,excel,pdf,zip,image"></c-form-item>
				<c-button slot="button" size="m" @click="submitHandle">提交申请</c-button>
			</c-form>
		</module>
	</app>
</template>

<script>
	export default {
		props: {
			id: String,
			projectId: String
		},
		
		data() {
			return {
				projectList: [],
				currentProjectId: ''
			}
		},
		
		watch: {
			currentProjectId(val) {
				if (val) {
					this.request({
						url: '/project/detail',
						data: {
							project_id: val
						},
						success: data => {
							if (this.id) {
								this.$refs.form.set({
									yzdw_name: data.project_info.yzdw_name,
									jldw_name: data.project_info.jldw_name,
									zbqy_name: data.project_info.zbqy_name
								});
							} else {
								this.$refs.form.set(data.project_info);
							}
						}
					});
				}
			}
		},
		
		mounted() {
			this.request({
				url: '/project/select_list',
				data: {
					type: 4
				},
				success: data => {
					this.projectList = Array.from(data, item => {
						return {
							name: item.name,
							value: item.id
						}
					});
				}
			});
			
			if (this.id) {
				this.request({
					url: '/project/ry/detail',
					data: {
						ry_id: this.id
					},
					success: data => {
						this.$refs.form.set({
							ry_id: this.id
						});
						this.$refs.form.set(data.ryInfo);
					}
				});
			} else if (this.projectId) {
				this.$refs.form.set({
					project_id: this.projectId
				});
			}
		},
		
		methods: {
			submitHandle() {
				this.$refs.form.submit({
					url: this.id ? '/project/ry/updateBase' : '/project/ry/add',
					rule: {
						project_id: '请选择项目名称',
						xmjl_xm: '请填写项目经理',
						xmjl_lxdh: '请填写项目经理电话',
						jszg_xm: '请填写技术总工',
						jszg_lxdh: '请填写技术总工电话',
						aqy_xm: '请填写安全员',
						sgy_xm: '请填写施工员',
						zjy_xm: '请填写质检员'
					},
					success: () => {
						this.$message({
							text: '提交成功'
						});
						this.navigateTo('/transact/person_change');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
